import * as LDClient from 'launchdarkly-js-client-sdk';
import {BaseClient} from './base';

export interface LaunchDarklyConfig {
    envKey: string;
    user: LDClient.LDUser;
    options?: LDClient.LDOptions;
}

export class LaunchDarklyClient implements BaseClient {
    private _client: LDClient.LDClient;
    public configure(config: LaunchDarklyConfig): void {
        const {envKey, user, options} = config;
        this._client = LDClient.initialize(envKey, user, options);
    }
    public async getFlagValue(key: string, defaultValue?: unknown): Promise<unknown> {
        return await this._client.variation(key, defaultValue);
    }
}
